import { Link } from '@tanstack/react-router';
import { LogOut } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { useAuthenticatedUser } from '@/components/providers/AuthenticatedUserProvider';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

import { useMenuList } from './useMenuList';

export const Menu = (): JSX.Element => {
  const { signOut } = useAuthenticatedUser();
  const menuList = useMenuList();

  return (
    <nav className="mt-4 h-full w-full flex flex-col justify-between">
      <ul className="flex flex-col items-start justify-between grow basis-0 h-full">
        {menuList.map(({ menus }, menuListIndex) => (
          <li className="w-full flex flex-col items-center" key={menuListIndex}>
            <div className="pb-2"></div>
            {menus.map(({ to, label, icon: Icon, active }, menuIndex) => (
              <div className="w-full" key={menuIndex}>
                <TooltipProvider disableHoverableContent>
                  <Tooltip delayDuration={100}>
                    <TooltipTrigger asChild>
                      <Button
                        variant={active ? 'secondary' : 'ghost'}
                        className="w-full justify-start h-10 mb-1"
                        asChild
                      >
                        <Link to={to}>
                          <Icon size={18} />
                          <p className={cn('max-w-[200px] truncate ml-2')}>
                            {label}
                          </p>
                        </Link>
                      </Button>
                    </TooltipTrigger>
                  </Tooltip>
                </TooltipProvider>
              </div>
            ))}
          </li>
        ))}
      </ul>
      <div className="w-full flex items-end">
        <TooltipProvider disableHoverableContent>
          <Tooltip delayDuration={100}>
            <TooltipTrigger asChild>
              <Button
                onClick={signOut}
                variant="outline"
                className="w-full justify-center h-10 mt-5"
              >
                <span>
                  <LogOut size={18} />
                </span>
                <p className="ml-4">
                  <FormattedMessage id="global.menu.signOut" />
                </p>
              </Button>
            </TooltipTrigger>
          </Tooltip>
        </TooltipProvider>
      </div>
    </nav>
  );
};
